import { curry } from "ramda";
import {
  combineArray as mostCombineArray,
  concatMap as mostConcatMap,
  debounce as mostDebounce,
  delay as mostDelay,
  mergeArray as mostMergeArray,
  recoverWith as mostRecoverWith,
  until as mostUntil,
} from "most";

export const combineArray = curry(mostCombineArray);
export const concatMap = curry(mostConcatMap);
export const debounce = curry(mostDebounce);
export const delay = curry(mostDelay);
export const mergeArray = curry(mostMergeArray);
export const recoverWith = curry(mostRecoverWith);
export const until = curry(mostUntil);
